export default function* watchPollStatusSaga() {
  //------this function is calling getStatus/status saga------//
}
